<template>
  <v-container fluid>
    <v-skeleton-loader
      class="mb-6"
      type="card-avatar, article, list-item-avatar, list-item-avatar"
      v-if="showSkeleton"
    ></v-skeleton-loader>
    <div v-if="!showSkeleton && elements != null">
      <v-row>
        <v-col cols="12" md="10" offset-md="1" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <template v-for="(item, idx) of elements">
            <component
              class="mb-10"
              :is="`${$componentIs(item.template)}`"
              :key="`el_${idx}`"
              :content="item"
            ></component>
          </template>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { EventBus } from "@/event-bus";
import UnknowComponent from "@/components/UnknowComponent.vue";
import BannerSlider from "@/components/BannerSlider.vue";
import CategoryHorizontalListView from "@/components/CategoryHorizontalListView.vue";
import CourseVerticalGridView from "@/components/CourseVerticalGridView.vue";
import GradeHorizontalListView from "@/components/GradeHorizontalListView.vue";
import MyCourseVerticalGridView from "@/components/MyCourseVerticalGridView.vue";
import TagListView from "@/components/TagListView.vue";
import TeacherHorizontalListView from "@/components/TeacherHorizontalListView.vue";
export default {
  name: "Home",
  components: {
    BannerSlider,
    CategoryHorizontalListView,
    CourseVerticalGridView,
    GradeHorizontalListView,
    MyCourseVerticalGridView,
    TagListView,
    TeacherHorizontalListView,
    UnknowComponent
  },
  data: () => ({
    loading: false,
    elements: null,
    showSkeleton: true
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let token = this.$cookies.get("user_token")
      let company = Vue.prototype.$userInfo.companies[0]._id
      this.loading = true;
      this.$http
        .get(`${this.$store.state.api}/home/V2?index=0${token ? "": "&companyID="+ company}`)
        .then(resp => {
          if (resp.status == 200 && resp.data.status == true) {
            this.elements = resp.data.result.elements;
            EventBus.$emit("updateNavBar", resp.data.result.navBarTitle);
            this.showSkeleton = false;
          }
        })
        .catch(err => {})
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
